<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="up" icon="up" bold :text="lang.button_Up" :tooltip="lang.button_Up"
            :disabled="upButtonStatus" />

          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader'" v-show="!isEdit && !isSecondLevel"
            @click="edit" icon="edit" bold :text="lang.button_Edit" :tooltip="lang.button_Edit"
            :disabled="editButtonStatus" />
          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader'" v-show="isEdit" @click="unedit"
            icon="edit" bold :text="lang.button_Unedit" :tooltip="lang.button_Unedit" :disabled="uneditButtonStatus" />
          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader'" v-show="!isSecondLevel" @click="save"
            icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus"
            :save="saveStatus" />

          <action-button v-show="isPlugin||isAgent" @click="checkLocalLibrary" icon="open" bold :text="lang.button_Open"
            :tooltip="lang.button_Open" :disabled="openButtonStatus" />
          <action-button v-if="buttonIsVisible&&!isSecondLevel" v-show="isPlugin||isAgent" @click="push" icon="import"
            bold :text="lang.button_Push" :tooltip="lang.button_Push" :disabled="pushButtonStatus" />

          <action-button v-if="currentUser.role != 'Reader'" @click="derive" icon="derive" bold
            :text="lang.button_Derive" :tooltip="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="currentUser.role == 'Admin' && globalSettings.deletionOfElements" @click="_delete"
            icon="remove" bold :text="lang.button_Delete" :tooltip="lang.button_Delete"
            :disabled="deleteButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="removeRevision" icon="remove" bold
            :text="lang.button_RemoveRevision" :tooltip="lang.button_RemoveRevision"
            :disabled="removeRevisionButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="withdraw" icon="withdraw" bold
            :text="lang.button_Withdraw" :tooltip="lang.button_Withdraw" :disabled="withdrawButtonStatus" />
          <action-button v-if="currentUser.role == 'Admin'" @click="moveTo" icon="move-to" bold
            :text="lang.button_MoveTo" :tooltip="lang.button_MoveTo" :disabled="moveToButtonStatus" />


          <action-button v-show="currentUser.role == 'Admin' && isPending == true" @click="transferOwnership"
            icon="move-to" bold :text="lang.button_TransferOwnership" :tooltip="lang.button_TransferOwnership"
            :disabled="transferOwnershipButtonStatus" />


        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'

  import Content from "@/components/LibraryManager/Views/LibraryDetails/Middle/Content/Content"
  import { mapGetters } from 'vuex'
  import * as Tools from '../../../../../Tools/Tools'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      saveButtonStatus: true,
      editButtonStatus: false,
      uneditButtonStatus: true,
      backButtonStatus: false,
      upButtonStatus: false,
      openButtonStatus: false,
      pushButtonStatus: false,
      transferOwnershipButtonStatus: false,
      deriveButtonStatus: false,
      deleteButtonStatus: false,
      removeRevisionButtonStatus: false,
      withdrawButtonStatus: false,
      moveToButtonStatus: false,
      saving: false,
      //lockedRevisionId: "",
      fileCounter: 0,
      fileFeedback: [],
      pushed: false,
      libraryDetails: {},
      
    }
  },
  computed:{
    ...mapGetters({
      currentUser: 'currentUser',
      isPlugin: 'isPlugin',
      globalSettings: "globalSettings",
      isAgent: 'isAgent',
      
    }),
    isSecondLevel(){
      return this.$store.getters.isSecondLevel;
    },
    isEdit(){
      return this.$store.getters.isEditPropertyForm;
    },
    lastRevisionHistory(){
      
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++){
        
        if (tab[i].revision > obj.revision){
          obj = tab[i];
        }
      }
      
      return obj;
    },
    selectedLastRevisionRow(){
      if (this.$store.getters.selectedRevisionRow.length == 0){
        return false;
      }
      
      return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
    },
    authorityToChange(){
      return this.$store.getters.authorityToChange;
    },
    elementStatus(){
      if (this.lastRevisionHistory == undefined){
        return 
      }
      return this.lastRevisionHistory.status.display;
    },
    buttonIsVisible(){
      
      let ret = false;
      if (this.selectedLastRevisionRow && this.authorityToChange && this.isOwner) {
      
        ret = true;
      }
      if (this.elementStatus == "active"){
        ret = true;
      }
      
      return ret;
    },
    isPending() {
      if (this.lastRevisionHistory != undefined) {
        return this.lastRevisionHistory.status.display == "pending";
      }
      return "";
    },
    isOwner() {
      
      let ret = false;
      if (this.lastRevisionHistory.userId == this.currentUser.userId) {
        ret = true;
      }
      return ret;
    },
    saveStatus() {
      return this.$store.getters.saveStatus;
    },
    

  },
  created() {

    //this.getDetails();
    
  },
  watch: {
    isEdit: function(newVal){
      

        this.saveButtonStatus = !newVal;
        this.editButtonStatus = newVal;
        this.uneditButtonStatus = !newVal;

    },
    
    lastRevisionHistory: {
      handler: function(newVal, oldVal){
        
        
        this.getDetails();
      },
      deep: true
        
          
    },
  },

  methods: {
    getDetails() {

      let vue = this;

      if (this.lastRevisionHistory == null) {
        return;
      }

      const obj = {
        libraryRevisionId: this.lastRevisionHistory.id
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibraryDetails", obj)
        .then((result) => {

          console.log(result);

          if (result.status == "OK") {
            if (result.data != null) {
              vue.libraryDetails = result.data;
            }
            
          }

          

      })
      
    },
    edit(){
      

      this.$store.dispatch("editPropertiesForm", true);
    },
    unedit(){
      

      this.$store.dispatch("editPropertiesForm", false);
      this.$store.dispatch("setSaveStatus", false);
    },
    save(){
      this.saveButtonStatus = true;

      let vue = this;
      
      //let libraryName = this.$store.getters.selectedRows[0].col___name.value.display;
      

      let trig = false;
        for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
          if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true)&&(this.$store.getters.propertyToSaving[i].value == "")){
            trig = true;
            break;
          }
        }
        
        if (trig == true){
          let obj = {
            text: this.lang.alert_error_edit_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
          vue.saveButtonStatus = false;
        }else{
          let revisionId = "";
          const tab = this.$store.getters.selectedRevisionRow
            let rev = 0;
            let revId = "";
            for (let i = 0, lei = tab.length; i < lei; i++){
              
              if (tab[i].revision > rev){
                rev = tab[i].revision;
                revId = tab[i].revisionId;
              }
              
            }
            revisionId = revId;

          let obj = {
            revisionId: revisionId,//this.$store.getters.selectedRows[0].col___revisionId.revisionId,
            values: this.$store.getters.propertyToSaving
          }

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateLibrary", obj)
          .then(function(result){
            vue.saveButtonStatus = false;
            console.log(result)

            if (result.status == "OK"){

              if (result.data != 0){
                //revisionId = result.data;

                //const goalObj = result.data;

                let revisionId = result.data;

                vue.saving = true;

              let obj = {
                text: vue.lang.alert_success_edit_library,
                time: 10,
                type: "success"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch("setSaveStatus", false);

              if (vue.$store.getters.libraryFilesToSaving.length > 0){

                 
                vue.fileCounter = 0;

                vue.importFile(revisionId);
                
              }else{

                const reloadObj = {
                  status: true,
                  name: "RevisionTableComponent",
                  source: ""
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
              }



              }else{

                let obj = {
                  text: vue.lang.alert_error_edit_library + ".",
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

              }
              

              

              

            }else{

              

              let obj = {
                text: vue.lang.alert_error_edit_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

            }



          })


        }



      




    },
    transferOwnership() {

      let vue = this;

      let funcYes = function (e) {

        let transferOwnershipForm = vue.$store.getters.transferOwnershipForm;



        let obj = {
          revisionId: vue.lastRevisionHistory.id,
          userId: transferOwnershipForm.userId
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_transferOfOwnership", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                
                vue.$store.dispatch("setAuthorityToChange", true);

                let obj = {
                  text: vue.lang.alert_success_TransferOwnership,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                let reloadObj = {
                  status: true,
                  name: "RevisionTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                reloadObj = {
                  status: true,
                  name: "HistoryDetailsComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                reloadObj = {
                  status: true,
                  name: "TasksComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              } else {
                let obj = {
                  text: vue.lang.alert_error_TransferOwnership + ". ",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_TransferOwnership + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "transferownership",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_TransferOwnership,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
    },
    importFile(revisionId){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      let vue = this;
      
      let lei = vue.$store.getters.libraryFilesToSaving.length;
      


      const obj = {
        revisionId: revisionId,
        file: vue.$store.getters.libraryFilesToSaving[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.$store.getters.libraryFilesToSaving[vue.fileCounter].lastModified)
        //lastModified: vue.$store.getters.libraryFilesToSaving[vue.fileCounter].lastModified
      }
      
      let fileName = vue.$store.getters.libraryFilesToSaving[vue.fileCounter].name;

      vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importFiles", obj)
      .then(function(result){
        console.log(result);
        let obj2 = {};
        if (result.status == "OK"){
          
          obj2 = {
            result: "Added",
            fileName: fileName,            
            otherLibraries: []
          }
          
        }else{
          
          
          obj2 = {
            result: result.message,
            fileName: fileName,            
            otherLibraries: []
          }
          
          
        }
        vue.fileFeedback.push(obj2);
        
        
        vue.fileCounter++;
        
          if (vue.fileCounter > lei - 1){
            
            const reloadObj = {
              status: true,
              name: "RevisionTableComponent",
              source: ""
            }
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            

            let func = function () {
              vue.fileFeedback = [];
               
            }
            

            const dataFiles = {
              fileImportResults: {},
              newRevisionId: null
            }
            for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

              const obj = {
                result: vue.fileFeedback[i].result,
                          
                otherLibraries: []
              }
              
              dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
            }
            vue.$store.dispatch("showLoader", {visible: false, text:""});
            vue.fileFeedback = [];

            let trig = false;
            for (let item in dataFiles.fileImportResults) {
              
              if (dataFiles.fileImportResults[item].result == "Added" || dataFiles.fileImportResults[item].result == "Successful parsing. Dependency description file will not be added." || dataFiles.fileImportResults[item].result == "Excluded file type.") {
                
              } else {
                
                trig = true;
                break;
              }
            }
          
            let buttonWait = null;
            let commentWait = "";
            if (trig) {
              buttonWait = 10;
              commentWait = vue.lang.modal_buttonWaitAlert;
            }
          
            const obj = {
              title: vue.lang.modal_title_PushLibrary,
              text: "",
              type: "push_files",
              buttons: 1,
              buttonName: "Close",
              buttonWait: buttonWait,
              commentWait: commentWait,
              size: "xl",
              lang: vue.lang.modal_PushLibrary,
              funcNo: "",
              funcYes: "",
              funcCustom: func,
              data: dataFiles
            };
            vue.$store.dispatch("showModalComponent", obj);
            
          }else{
            
            vue.importFile(revisionId);
          }

      })
    },
    checkLocalLibrary(){
      let vue = this;
      
      
      const obj = {
        revisionId: this.lastRevisionHistory.id,
        type: this.libraryDetails.libraryType,
        name: this.libraryDetails.name,
        category: this.libraryDetails.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkLibrary", obj)
      .then((result) => {
        console.log(result);
        if (result.status == "OK"){

          let files = result.data.localFiles;
          let path = result.data.localPath;

          if (files.length > 0){
            let funcRemote = function(){
              
              
            
              vue.open();
           
            }
            let funcLocal = function () {
              vue.openLocal();
            }

            const obj = {
              title: vue.lang.alert_title_openLibrary,
              text: vue.lang.alert_openLibrary_1 + " (" + path + "). " + vue.lang.alert_openLibrary_2,
              type: "openrepo",
              buttons: 3,
              size: "lm",
              func1: funcRemote,
              func2: funcLocal,
              func3: "",

            }
    
            vue.$store.dispatch("showAlert", obj);
          }else{
            vue.open();
          }
        
        }else{

          let obj = {
            text: vue.lang.alert_error_CheckLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }
        
      })
        

    },
    open(){

      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "open"});
      
      const obj = {
        revisionId: this.lastRevisionHistory.id,
        type: this.libraryDetails.libraryType,
        name: this.libraryDetails.name,
        category: this.libraryDetails.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_openLibrary", obj)
      .then((result) => {

        console.log(result);
        vue.$store.dispatch("showLoader", {visible: false});

        if (result.status == "OK"){
          let obj = {
            text: "",
            time: 10,
            type: "success"
          }
                  
          if (result.data.openLibraryResult == null){
            // obj = {
            //   text: "Error",
            //   time: 15,
            //   type: "danger"
            // }
            // vue.$store.dispatch("displayFooterAlert", obj);
            return
          }


          
          if (result.data.openLibraryResult.status == "OK"){
            obj = {
              text: vue.lang.alert_success_OpenLibrary + " " + result.data.openLibraryResult.data,
              time: 10,
              type: "success"
            }
            
          }else{
            obj = {
              text: vue.lang.alert_error_OpenLibrary + result.data.openLibraryResult.message,
              time: 15,
              type: "danger"
            }
          }
          
          vue.$store.dispatch("displayFooterAlert", obj);

        }else{
          let obj = {
            text: vue.lang.alert_error_OpenLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }

        
      })
      .catch((reason) => {

        console.log("Error:", reason)

        vue.$store.dispatch("showLoader", { visible: false });
      })
    },
    openLocal() {
      let vue = this;
      this.$store.dispatch("showLoader", { visible: true, text: "open" });

      const obj = {
        revisionId: this.lastRevisionHistory.id,
        type: this.libraryDetails.libraryType,
        name: this.libraryDetails.name,
        category: this.libraryDetails.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_openLibraryLocally", obj)
        .then((result) => {

          console.log(result);
          vue.$store.dispatch("showLoader", { visible: false });

          if (result.status == "OK") {
            let obj = {
              text: "",
              time: 10,
              type: "success"
            }

            if (result.data.openLibraryResult == null) {
              // obj = {
              //   text: "Error",
              //   time: 15,
              //   type: "danger"
              // }
              // vue.$store.dispatch("displayFooterAlert", obj);
              return
            }



            if (result.data.openLibraryResult.status == "OK") {
              obj = {
                text: vue.lang.alert_success_OpenLibrary + " " + result.data.openLibraryResult.data,
                time: 10,
                type: "success"
              }

            } else {
              obj = {
                text: vue.lang.alert_error_OpenLibrary + result.data.openLibraryResult.message,
                time: 15,
                type: "danger"
              }
            }

            vue.$store.dispatch("displayFooterAlert", obj);

          } else {
            let obj = {
              text: vue.lang.alert_error_OpenLibrary + ": " + result.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })
        .catch((reason) => {

          console.log("Error:", reason)

          vue.$store.dispatch("showLoader", { visible: false });
        })
    },
    push(){

      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      const obj = {
        revisionId: this.lastRevisionHistory.id,
        type: this.libraryDetails.libraryType,
        name: this.libraryDetails.name,
        category: this.libraryDetails.category
      }
      

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_pushLibrary", obj)
      .then((result) => {


        console.log(result);
                

        if (result.status == "OK"){
          //result.data.lockedRevisionId = vue.lockedRevisionId.col___revisionId.revisionId;

          let func = function(){
            
            if (result.data.newRevisionId == null){
              const reloadObj = {
                status: true,
                name: "RevisionTableComponent"
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            } else {
              
              const reloadObj = {
                  status: true,
                  name: "RevisionTableComponent"
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            }
            vue.pushed = true;

            
            let otherLibraries = [];
            
            for (let item in result.data.fileImportResults) {

              if (result.data.fileImportResults[item].otherLibraries.length > 0) {

                otherLibraries = result.data.fileImportResults[item].otherLibraries;
                
              }

            }
            let trig = false;
            for (let i = 0, lei = otherLibraries.length; i < lei; i++) {
              
                if (otherLibraries[i].status != "active") {
                  trig = true;
                }
                if (otherLibraries[i].files != true) {
                  trig = true;
                }
              

            }
            
            if (trig == true) {
              let func = function () {
                
              }
              const obj = {
                title: "",
                text: "",
                type: "new_libraries_request",
                buttons: 1,
                buttonName: "Close",
                size: "xl",
                lang: vue.lang.modal_NewLibrariesRequest,
                funcNo: "",
                funcYes: "",
                funcCustom: func,
                data: result.data
              };
              vue.$store.dispatch("showModalComponent", obj);
            }

            let reloadObj = {
              status: true,
              name: "WhatIsIncludedComponentDetails"
            }
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            reloadObj = {
              status: true,
              name: "PinsTableComponent"
            };
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            reloadObj = {
              status: true,
              name: "WhereLibUsedComponent"
            };
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            reloadObj = {
              status: true,
              name: "WhereUseTableComponent"
            };
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

          }

          vue.$store.dispatch("showLoader", { visible: false });

          

          
          let trig = false;
          for (let item in result.data.fileImportResults) {
           
            if (result.data.fileImportResults[item].result == "Added" || result.data.fileImportResults[item].result == "Successful parsing. Dependency description file will not be added." || result.data.fileImportResults[item].result == "Excluded file type.") {
              
            } else {
              
              trig = true;
              break;
            }
          }
          
          let buttonWait = null;
          let commentWait = "";
          if (trig) {
            buttonWait = 10;
            commentWait = vue.lang.modal_buttonWaitAlert;
          }
          const obj = {
            title: vue.lang.modal_title_PushLibrary,
            text: "",
            type: "push_files",
            buttons: 1,
            buttonName: "Close",
            buttonWait: buttonWait,
            commentWait: commentWait,
            size: "xl",
            lang: vue.lang.modal_PushLibrary,
            funcNo: "",
            funcYes: "",
            funcCustom: func,
            data: result.data
          };
          
          vue.$store.dispatch("showModalComponent", obj);

          
          
        }else{
          vue.$store.dispatch("showLoader", { visible: false });
          let obj = {
            text: vue.lang.alert_error_PushLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

        
      })

    },
    derive() {

      let to = "/LibraryManager/LibraryDerive";

      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   source: "LibraryDetails",
      //   //end: true,
      //   //revisionId: this.$route.query.revisionId,
      //   revisionId: this.$store.getters.selectedRevisionRow[0].revisionId,
      //   id: this.$route.query.id
        
      // }

      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: this.$store.getters.selectedRevisionRow[0].revisionId,
        id: this.$route.query.id,
        sourceType: "details",
        sourceId: this.$route.query.id,
        sourceRevisionId: this.$store.getters.selectedRevisionRow[0].revisionId,
        currentRevisionId: this.$store.getters.selectedRevisionRow[0].revisionId,
        //bomId: this.$store.getters.selectedBomRow[0].bomId,
        end: false,
        source: "LibraryDetails",
      }
      
      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      this.$router.push({ path: to, query: routingObject });
      
    },
    _delete() {

      let vue = this;

      let libraryId = this.$route.query.id;

      let deleteLibraryFunc = function () {

        
        const arr = {
          libraryIds: [libraryId]
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkDeleteLibrary", arr)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {

                
                if (result.data[0].success == true) {
                  obj = {
                    text: vue.lang.alert_success_delete_library,
                    time: 10,
                    type: "success"
                  }

                  const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiLibComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  let to = "/LibraryManager/LibraryTable";
                  const query = {
                    from: vue.$route.path,
                    to: to,
                    source: "LibraryDetails",

                  }

                  vue.$router.push({ path: to, query: query });
                } else {
                  obj = {
                    text: vue.lang.alert_error_delete_library + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }
                }
                  
                
                

              } else {
                obj = {
                  text: vue.lang.alert_error_delete_library + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_delete_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_delete,
        text: vue.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteLibraryFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    removeRevision() {

      let vue = this;

      let revisionId = this.lastRevisionHistory.id;
      //let revisionId = this.$route.query.revisionId;
      
      let removeFunc = function () {
        const obj = {
          libraryRevisionIds: [revisionId]
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkRemoveRevision", obj)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {

                if (result.data[0].success == true) {
                  obj = {
                    text: vue.lang.alert_success_removeRevision_library,
                    time: 10,
                    type: "success"
                  }

                  const reloadObj = {
                    status: true,
                    name: "RevisionTableComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  
                } else {
                  obj = {
                    text: vue.lang.alert_error_removeRevision_library + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }
                  
                }
                

              } else {
                obj = {
                  text: vue.lang.alert_error_removeRevision_library + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_removeRevision_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_removeRevision,
        text: vue.lang.alert_removeRevision,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: removeFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    withdraw() {

      let alert_success_withdraw = this.lang.alert_success_withdraw;
      let alert_error_withdraw = this.lang.alert_error_withdraw;

      let libraryId = this.$route.query.id;

      let withdrawLibraries = function (_vue) {
        const arr = [libraryId];


        
        const obj = {
          libraryIds: arr
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_bulkSetWithdraw", obj)
          .then((result) => {

            console.log(result)
            if (result.status == "OK") {

              if (result.data != null) {

                if (result.data[0].success == true) {
                  let obj = {
                    text: alert_success_withdraw,
                    time: 10,
                    type: "success"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);

                  const reloadObj = {
                    status: true,
                    name: "RevisionTableComponent"
                  }
                  _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                } else {
                  let obj = {
                    text: alert_error_withdraw + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
                

              } else {
                let obj = {
                  text: alert_error_withdraw + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: alert_error_withdraw + ": " + result.message,
                time: 10,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

            }
          })

      }

      const obj = {
        title: "Withdraw",
        text: this.lang.alert_withdraw,
        type: "withdraw",
        buttons: 2,
        size: "sm",
        funcYes: withdrawLibraries,
        funcNo: "",

      }

      this.$store.dispatch("showAlert", obj);
      
    },
    moveTo() {

      let vue = this;


      let funcYes = function (e) {

        let newMovingCategory = vue.$store.getters.newMovingCategory;

        let obj = {
          libraryIds: newMovingCategory.libraryIds,
          categoryId: newMovingCategory.categoryId
        }

        if (obj.categoryId == undefined) {
          let obj = {
            text: vue.lang.alert_error_MoveLibraryCategory,
            time: 15,
            type: "danger"
          };

          vue.$store.dispatch("displayFooterAlert", obj);
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          return;
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkMoveToAnotherCategory", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                let obj = {
                  text: vue.lang.alert_success_MoveLibrary,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                const reloadObj = {
                  status: true,
                  name: "InfoElementComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                vue.saving = true;

              } else {
                let obj = {
                  text: vue.lang.alert_error_MoveLibrary,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_MoveLibrary,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "moving",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_Moving,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
    up(){
      this.$store.commit("RESETROUTINGDATA");

      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }
      if (this.pushed == true) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        this.pushed = false;
      }

      let to = "/LibraryManager/LibraryTable";
      
      this.$router.push({ path: to });

    },
    back() {

      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");

      if (this.$route.query.pushed == true) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        this.pushed = false;
      }
      if (this.pushed == true) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        this.pushed = false;
      }

      if (this.saving) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }

      //#####################################################################
      let query = {};
      let to = "";

      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }
        }

        
      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId
        }
        if (to == "/ProjectManager/ProjectBom") {
          query.bomId = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId;

        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {

          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }]
          }
          this.selectRow(goalObj);
        }
       
        this.$store.commit("BACKROUTINGDATA");
      }

      
      
      this.$router.push({ path: to, query: query });
      
    },
    selectRow(goalObj) {
      

      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/ProjectManager/ProjectDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }




      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>
  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails/Middle/Middle.vue